<div class="row">
  <div class="col-md-12 popin-container space-between">
    <div class="customerBox">
      <mat-icon class="icon valign-customer" matTooltip="Société" matSuffix>apartment</mat-icon>
      <strong class="customerIdentity">{{ customerName }}</strong>
      <a routerLink="/{{ visitRandomId }}/{{ uri }}/edit" class="float-right"><strong>Ce n'est pas moi</strong></a><br>
      {{ customerActivity }} à {{ customerCity }}
    </div>
    <div class="text-center">
      <h3>Merci <strong>{{ this.customerName }}</strong>, voici quelques liens qui pourraient vous intéresser</h3>
    </div>
    <div class="buttonsBox">
      <a (click)="redirectTo('redirect/1/' + link1)"><button type="button" class="btn btn-primary m-2">{{ title1 }}</button></a>
      <a (click)="redirectTo('redirect/2/' + link2)" *ngIf="link2"><button type="button" class="btn btn-primary m-2">{{ title2 }}</button></a>
      <a (click)="redirectTo('redirect/3/' + link3)" *ngIf="link3"><button type="button" class="btn btn-primary m-2">{{ title3 }}</button></a>
    </div>
    <div class="text-center">
      <a (click)="redirectTo('/exit-popin')" style="cursor: pointer;"><strong>Laissez moi découvrir le site</strong></a>
    </div>
  </div>
</div>
